import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ERaLogin } from '../../../models/era/ERaLogin';
import { UtilsService } from '../../../services/utils.service';
import { EraService } from '../../../services/era.service';
import { Card } from 'primeng/card';
import { Message } from 'primeng/message';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-era-login',
  templateUrl: './era-login.component.html',
  styleUrls: ['./era-login.component.scss'],

  imports: [Card, Message, TranslatePipe, RouterLink, ButtonDirective]
})
export class EraLoginComponent implements OnInit {
  public loginEvent = '';
  public eraLoginInfo: ERaLogin | undefined = undefined;
  public errorMessage: any | undefined = undefined;
  public retry = false;
  public eraError = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private eraService: EraService,
    private utilsService: UtilsService
  ) {}

  async ngOnInit(): Promise<void> {
    this.activatedRoute.data.subscribe(async (result) => {
      this.loginEvent = result.loginEvent;
      switch (this.loginEvent) {
        case 'login':
          this.eraLogin();
          break;
        case 'confirm':
          await this.eraConfirm();
          break;
        case 'unlock':
          this.eraUnlockSession();
          break;
      }
    });
  }

  /**
   * Fetch the eRa login information and redirects user to eRa login page.
   */
  eraLogin(): void {
    const obs = this.eraService.eraLogin();
    if (!obs) {
      return;
    }
    obs.subscribe(
      (result) => {
        this.eraLoginInfo = result;
        if (this.eraLoginInfo && this.eraLoginInfo.login_url) {
          window.location.href = this.eraLoginInfo.login_url;
        }
      },
      (error) => {
        // Initiating the eRa login itself failed (e.g. ERA_NOT_CONFIGURED) -
        // there is no eRa login in flight to protect a background 401
        // against, so disarm the guard AuthService armed on login rather
        // than leaving UnathorizedInterceptor's safety net permanently off
        // for this session.
        this.eraService.setEraConfirmInProgress(false);
        this.utilsService.showError(error.message);
        this.retry = true;
        this.eraError = true;
      }
    );
  }

  /**
   *
   */
  async eraConfirm(): Promise<void> {
    this.eraService.setEraConfirmInProgress(true);
    try {
      await this.eraService.eraLoginConfirm();
      this.retry = false;
      this.eraError = false;
      await this.router.navigate(['/home']);
    } catch (error: any) {
      this.utilsService.showError(error.message);
      this.retry = true;
      this.eraError = true;
    } finally {
      this.eraService.setEraConfirmInProgress(false);
    }
  }

  /**
   *
   */
  async eraUnlockSession(): Promise<void> {
    const successUrl = '';
    const failureUrl = '';
    // window.location.href = this.eraLoginInfo.login_url;
  }
}
